import { useQuery } from '@tanstack/react-query'
import { TLanguage } from 'shared/types'
import { api } from '..'
import { API_URL } from 'config/env'

export const getLanguages = () =>
  api
    .get<TLanguage[]>(`${API_URL}/v1/translations/languages`)
    .then(({ data }) => {
      const entries = Object.entries(
        data.reduce((lookup: Record<string, TLanguage>, curr) => {
          lookup[curr.code] = curr

          return lookup
        }, {}),
      )

      return new Map(entries)
    })

export const useGetLanguages = () =>
  useQuery({
    queryFn: getLanguages,
    queryKey: ['languages'],
  })
